import { DateText } from '@stories/Components/DateText/DateText.tsx'

export interface DateTextProps {
  date: string
  id: number
}

export const CampItemRegister = ({ date, id }: DateTextProps) => {
  return (
    <span>
      Registers:{' '}
      <span data-testid={`registration-date-label-wrapper-camp-id-${id}`}>
        <span data-testid="registration-opens-label">
          <DateText date={date} />
        </span>
      </span>
    </span>
  )
}
